import React, { HTMLAttributes } from 'react'
import {ElementType, DOMAttributes, ReactNode, forwardRef} from 'react'
import classNames from 'classnames'

export type TextProps = HTMLAttributes<HTMLElement> & {
    tag?: ElementType
    bold?: boolean
    heavy?: boolean
    italic?: boolean
    color?: string
    children: ReactNode
    className?: string
    size?: 'smaller'|'small'|'normal'|'large'|'larger'|'largest'|number
    style?: React.CSSProperties
}

const fsMap: Record<string, number> = { 'largest': 1, 'larger': 2, 'large': 3, 'normal': 4, 'small': 5, 'smaller': 6 }

const Text = forwardRef<HTMLParagraphElement, TextProps>(({
    tag,
    bold,
    heavy,
    italic,
    size,
    color,
    className,
    children,
    style,
    ...otherProps
}, ref) => {

    const Tag: ElementType = tag || 'span'
    let fontSize: number|null = null

    if (size && typeof size === 'number') fontSize = size

    const _className = classNames(
        {
            [`text-${color}`]: color,
            [`fs-${fsMap[size as string]}`]: size && typeof size === 'string' && fsMap[size as string],
            'font-italic': italic,
            'fw-bold': bold,
            'weight-900': heavy
        },
        className)

    return (
        <Tag
            ref={ref}
            className={_className}
            style={{ ...style, fontSize, color: `var(--bs-${color})` }}
            {...otherProps}>
            {children}
        </Tag>
    )
})

export { Text }
